function goBack()
  {
  window.history.back()
  }

$(document).ready(function() {


	$(".email")
    	.val("Enter your e-mail address...")
    	.focus(function(){
        	if ($(this).val() == "Enter your e-mail address...") {
            	$(this).val("");
        	}
    	})
    	.blur(function(){
        	if ($(this).val() == "") {
            	$(this).val("Enter your e-mail address...");
        	}
    	});
		
		//<![CDATA[
		jQuery(function() {
		  jQuery('#main-nav li').each(function() {
		    var href = jQuery(this).find('a').attr('href');
		    if (href === window.location.pathname) {
		      jQuery(this).addClass('current');
		    }
		  });
		});  
		//]]>
	$('.has-dropdown a').hover(function(){
		//alert('wwww');
		//$(this).parent().children('ul').css('display','block');
	});
	
	  function navRollOver(){
	    $(this).children('ul').css('top', $(this).height()).show();
	  }
	  function navRollOut(){
	    $(this).children('ul').hide();
	  }

	
	 $('.has-dropdown').mouseenter(navRollOver);

	 $('.has-dropdown').mouseleave( navRollOut ); 
	
	
	//  $(".hover-element").hover(function(){
	//       $(this).children('div').slideDown(400);
	//  },function(){
	//      $(this).children('div').slideUp(400);    
	//  });
	
     
    $("#q")
    	.val("Search the site...")
    	.focus(function(){
        	if ($(this).val() == "Search the site...") {
            	$(this).val("");
        	}
    	})
    	.blur(function(){
        	if ($(this).val() == "") {
            	$(this).val("Search the site...");
        	}
    	});

		  $('.update').click(function() {
		    var params = {
		      type: 'POST',
		      url: '/cart/update.js',
		      data: jQuery('form[action="/cart"]').serialize(),
		      dataType: 'json',
		      async: false
		    };
		    $.ajax(params);
		  });        

});